export default "__VITE_ASSET__D4IS2nIX__"